import * as React from 'react';
import { useSelector } from 'react-redux';

import { DeveloperDescription as DeveloperDescriptionComponent } from '../../components/DeveloperDescription';
import { getDeveloperDescription } from '../../selectors';

export function DeveloperDescription() {
  const description = useSelector(getDeveloperDescription);

  if (!description) {
    return null;
  }

  return <DeveloperDescriptionComponent description={description} />;
}
